import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ODataService } from '@mynexus/mynexus-ui-lib';
import { HttpErrorHandler, HttpUtility } from '@core/http';
import { AuthenticationModule } from '@core/authentication/authentication.module';
import { MessageService } from 'primeng/api';
import {
  ConfigService,
  CONFIG_FILE,
  generateHashKey,
  registryUrlFactory,
  API_BASE_REGISTRY_URL
} from '@core/config/config.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, AuthenticationModule],
  providers: [
    { provide: 'windowRef', useValue: window },
    { provide: 'documentRef', useValue: document },
    ODataService,
    MessageService,
    HttpErrorHandler,
    HttpUtility,
    ConfigService,
    {
      provide: CONFIG_FILE,
      useValue: `../config.json?v=${generateHashKey()}`
    },
    {
      provide: API_BASE_REGISTRY_URL,
      useFactory: registryUrlFactory,
      deps: [ConfigService, CONFIG_FILE]
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule{
  // Ensure that CoreModule is only loaded into AppModule
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
   
  }
}
